import "./shared/styles/index.scss";
import AppRouter from "./config/routes";
import { useEffect, useState } from "react";
import { OfflinePage } from "./pages/offline-page/offline-page";
import { ReactComponent as CrossIcon } from "../src/shared/images/svg/cross.svg";
import { Provider } from "react-redux";
import { store } from "./store";


function App() {
  const [isOnline, setIsOnline] = useState(true);

  useEffect(() => {
    window.addEventListener("online", () => {
      setIsOnline(true);
    });

    window.addEventListener("offline", () => {
      setIsOnline(false);
    });
  }, [1]);

  if (isOnline) {
    return (
      <Provider store={store}>
        <AppRouter />
      </Provider>
    );
  } else {
    return <OfflinePage />;
  }
}

export default App;
